import { AnalyticCard } from "./AnalyticCard";

export function MetricCardNoData({
  title,
  tooltip,
}: {
  title: string;
  tooltip?: string;
}) {
  return (
    <AnalyticCard
      dataTestId="metric-card-no-data"
      title={title}
      titleJustifyBetween={false}
      tooltip={tooltip}
      variant="compact"
    >
      <div className="flex flex-col gap-0 justify-between items-start w-full h-full min-w-0">
        <div className="flex flex-col gap-0 w-full min-w-0">
          <p className="heading-4 text-text/secondary truncate w-full">-</p>
        </div>
      </div>
    </AnalyticCard>
  );
}
